import { SavePatch } from './undo.state.model';

export namespace UndoActions {
  export class Reset {
    static readonly type = '[Undo] Reset';
    constructor() {}
  }

  export class Undo {
    static readonly type = '[Undo] Undo';
    constructor(public chapterId: string) {}
  }

  export class UndoAll {
    static readonly type = '[Undo] Undo All';
    constructor(public chapterId: string) {}
  }

  export class Redo {
    static readonly type = '[Undo] Redo';
    constructor(public chapterId: string) {}
  }

  export class SavePatches {
    static readonly type = '[Undo] Store Patches';
    constructor(public patches: SavePatch[]) {}
  }
}
